import { FC, useEffect, useState } from 'react';
import { benchBrandsFields } from '../config';
import { useMethods } from '@lhb/hook';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';
import V2FormInputNumber from '@/common/components/Form/V2FormInputNumber/V2FormInputNumber';
import { Col, Form, Row } from 'antd';
import { CloseCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import styles from './../index.module.less';
import FormSetName from '@/common/components/Form/FormSetName';
import { isArray } from '@lhb/func';

const MAX_DATA_COUNT = 6; // 最大数据条数

/**
 * @Description 对标品牌
 */
const BenchBrands: FC<{
  propertyItem: any;
  form: any;
  disabled?: boolean;
  required?: boolean;
  infoChange?: any;
}> = ({
  propertyItem,
  form,
  disabled,
  required,
  infoChange
}) => {

  const [groupCount, setGroupCount] = useState(1);// 组个数
  const identification = propertyItem.identification; // 字段
  const value = Form.useWatch(identification);

  useEffect(() => {
    if (value?.length) {
      setGroupCount(value?.length);
    }
    infoChange?.(identification, value);
  }, [value]);

  const methods = useMethods({
    add() {
      if (disabled || (isArray(value) && value.length >= MAX_DATA_COUNT)) {
        return;
      }
      setGroupCount(groupCount + 1);
    },
    del(curIndex) {
      if (disabled) {
        return;
      }
      form.setFieldValue(identification, value.filter((item, index) => index !== curIndex));
      setTimeout(() => { setGroupCount(groupCount - 1); });
    }
  });

  return <div className={styles.benchBrands}>
    <FormSetName name={identification} initialValue={[]}></FormSetName>
    {Array.from({ length: groupCount })?.map((item, index) => <div key={index}>
      <Row gutter={24}>
        {benchBrandsFields?.map((field, idx) => {
          return <Col span={12} key={idx}>
            {
              field.type === 'text' && <V2FormInput
                label={field.label}
                name={[propertyItem.identification, index, field.name]}
                required={required}
                disabled={disabled}
                maxLength={field.maxlength}
                config={{ addonAfter: field.suffix }}
              ></V2FormInput>
            }
            {
              field.type === 'number' && <V2FormInputNumber
                label={field.label}
                name={[propertyItem.identification, index, field.name]}
                required={required}
                disabled={disabled}
                config={{ addonAfter: field.suffix }}
                max={field.maxValue}
                min={field.minValue}
                precision={field.floatLength}
              ></V2FormInputNumber>
            }
          </Col>;
        })}
      </Row>
      <div className={`operate-wrapper ${disabled ? 'disabled' : ''}`}>
        { value?.length > 1 && <div className='operate left' onClick={() => methods.del(index)}><CloseCircleOutlined className='mr-5 fs-16' />删除此条</div> }
        { (value?.length - 1) === index && (isArray(value) && value.length < MAX_DATA_COUNT) && <div className='operate right' onClick={methods.add}><PlusCircleOutlined className='mr-5 fs-16'/>新增一条</div> }
      </div>
    </div>)}
  </div>;
};

export default BenchBrands;
